import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { TokenStorageService } from './token-storage.service';
@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router, private tokenStorageService: TokenStorageService, ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const data = this.tokenStorageService.getUser();
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['/login']);
      return false;
    } else if (route.data.role && route.data.role.indexOf(data.user.role) === -1) {

      this.router.navigate(['/userAction']);
      return false;
    }
    return true;
  }
}
